import React, { useEffect, useState } from 'react';
import { Formik, Field, Form, ErrorMessage} from 'formik';
import * as Yup from 'yup';
import Navbar from './Navbar';
import { Auth } from '@aws-amplify/auth';
import { useNavigate } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.css';

const FileUploadForm = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [csvData, setCsvData] = useState([]);
    const [dataError, setDataError] = useState(false);
    const [showUploadButton, setShowUploadButton] = useState(false);
    const [buttonType, setButtonType] = useState('checkButton');
    const [uploadData, setUploadData] = useState([]);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [link, setLink] = useState('');
    const[linkText, setLinkText] = useState('');
    const [idToken, setIdToken] = useState('');
  
    const navigate = useNavigate();
  
    useEffect(() => {
        checkLogin();
    }, []);

    async function checkLogin() {
        try {
            const user = await Auth.currentAuthenticatedUser();
            setIdToken(user.signInUserSession.idToken.jwtToken);
            setIsLoggedIn(true);
            
         } catch {
            console.log('in fileuploadform: User not signed in');
            setIsLoggedIn(false);
            navigate('/login');
        }
    }
  
    useEffect(() => {
        
        if (isLoggedIn){
            console.log('Logged in');
            setLink('/logout');
            setLinkText('Logout');    
        }else{
            console.log('Not logged in');
            setLink('/login');
            setLinkText('Login');   

        }
    }, [isLoggedIn]);

    useEffect(() => {
        if (!dataError && csvData.length > 0) {
            setShowUploadButton(true);
            setButtonType('checkButton');
            console.log('useEffect if: ', csvData)
            console.log('useEffect data error if: ', dataError)
        }
        else{
            setShowUploadButton(false);
            setButtonType('checkButton');        
            console.log('useEffect else: ', csvData)
            console.log('useEffect data error else: ', dataError)
        }
    }, [dataError, csvData, buttonType]);

    useEffect(() => {
            
            setButtonType('checkButton');
            setShowUploadButton(false);    

    }, [uploadData]);
    
    const handleSubmit = async ({ file }) => {
 
        setIsLoading(true);
        console.log('start of handleSubmit buttonType: ', buttonType)

        if (buttonType === 'checkButton') {

            const reader = new FileReader();
            
            reader.onload = async (e) => {
                const text = e.target.result;
                // Process CSV data
                const data = processCSV(text);
                    setCsvData(data);
                    console.log(data)

                    // check if csv data is valid
                    if (data.length > 0) {
                        // check if csv data has the correct headers
                        //let headers = Object.keys(data[0]);
                        let headers = Object.keys(data[0]).toString().split(',');
                        const requiredHeaders = [ 
                            'uid',
                            'cr_card_number',
                            'email',
                            'aph',
                            'pass_number',
                            'pass_expiry',
                            'zones',
                            'staff_group',
                            'company_name',
                            'corporate_email',
                            'landside',
                            'aircrew',
                            'completed_training'

                        ];
                        const hasRequiredHeaders = requiredHeaders.every((header) => 
                            headers.includes(header)
                        );
                        
                        console.log(headers);

                        if (!hasRequiredHeaders) {

                            const missingHeaders = requiredHeaders.filter(header => !headers.includes(header));
                            console.log('Missing headers:', missingHeaders);

                            setDataError(true);
                            console.log(showUploadButton);
                            setIsLoading(false);
                            setButtonType('checkButton');

                        }
                        else{
                            setDataError(false);
                            //sendDataToApi(data);
                            console.log(showUploadButton);
                            setIsLoading(false);
                            setButtonType('checkButton');
                            
                        }
                    }   
                        
                };
                
            reader.readAsText(file);
            
            
        };
        if (buttonType === 'uploadButton') {
            // Send data to API
            await sendDataToApi(csvData);
        };

    };
  
    const processCSV = (str, delimiter = ',') => {
        // Split the input text into lines
        const lines = str.split('\n');
    
        // Extract headers (first line)
        const headers = lines[0].split(delimiter).map(header => header.trim());
    
        // Map the remaining lines into objects
        return lines.slice(1).map(line => {
        const values = line.split(delimiter).map(value => value.trim());
        console.log(values);
        return headers.reduce((object, header, index) => {
            object[header] = values[index];
            return object;
        }, {});
        });
    };
    
  
    const sendDataToApi = async (data) => {
        const apiUrl = 'https://1qk0vhgbua.execute-api.ap-southeast-1.amazonaws.com/prod/csv';

        await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': '70pP5oMTgE9IlNLym0zGN8YTNamYIr4U7xxOy4Jq',
                'Authorization': 'Bearer ' + idToken
            },
            body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then(data => {
            
            //console.log('Success:', data);
            setUploadData(data);
            setIsLoading(false);
        })
        .catch((error) => {
            console.error('Error:', error);
            setUploadData([]);
            setButtonType('checkButton');
            setIsLoading(false);
        });
    };

    const DataTable = ({ data }) => {

        if (!data || data.length === 0) {
            return null;
        }

        return (          
          <table className="csvTable"> 
            <thead>
              <tr>
                <th>UID</th>
                <th>CR Card Number</th>
                <th>Email</th>
                <th>Pass Number</th>
                <th>Pass Expiry</th>
                <th>Zones</th>
                {/* Add more headers as needed */}
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                
                <tr key={index}>
                  <td>{item.uid}</td>
                  <td>{item.cr_card_number}</td>
                  <td>{item.email}</td>
                  <td>{item.pass_number}</td>
                  <td>{item.pass_expiry}</td>
                  <td>{item.zones}</td>
                </tr>
              ))}
            </tbody>
          </table>
        );
      }

      const UploadTable = ({ data }) => {

        if (!data || !data.status) {
            return null;
          }

        return (
        <div>
            <label>Upload Results</label>
            <table className="uploadTable"> 
                <thead>
                <tr>
                    <th>Record</th>
                    <th>Identifier</th>
                    <th>Status</th>
                </tr>
                </thead>
                <tbody>
                {data.status.map((item, index) => {
                    const parts = item.split(' - ');
                    return (
                    <tr key={index}>
                        <td>{parts[0]}</td>
                        <td>{parts[1]}</td>
                        <td>{parts.slice(2).join(' - ')}</td>
                    </tr>
                    );
                })}
                </tbody>
            </table>
        </div>
        );
      }
      

    const CustomFileInput = ({ field, form }) => {
        const handleChange = (e) => {
            form.setFieldValue(field.name, e.target.files[0]);
        };
    
        return (
        <div>
            <input 
            id="file"
            name={field.name}
            type="file"
            onChange={handleChange}
            style={{ display: 'none' }}
            />
            <label htmlFor="file" className="choosefile-button-style">
            Select your file
            </label><br/>
            <div className="file-display-container">
                <div className="filename-container">
                    {field.value && <div className="file-name">{field.value.name}</div>}
                </div>
            </div>
        </div>
        );
    };

  const FileUploadSchema = Yup.object().shape({
    file: Yup.mixed()
      .required("A file is required")
      .test(
        "fileType",
        "Unsupported File Format",
        value => value && ['text/csv'].includes(value.type)
      ),
  });

    return (
        <Formik
        initialValues={{ file: null, submitType:'' }}
        onSubmit={handleSubmit}
        validationSchema={FileUploadSchema}
        >
        {({ errors, touched, setFieldValue }) => (
            <Form>

            <div className="flex-container-1">
                        
                <div className="upload-container">
                    
                    {/*}
                    <div className="navbar">                       
                        <a href="/mainmenu">Home</a>
                        <a href="/csv">Upload CSV</a>
                        <a href="/query">Query and Export</a>                
                    </div>
                    */}
                         <Navbar link={link} linkText={linkText}/>
                        {/*}
                            <a className="loginout-button-style" href={link}>{linkText}</a> 
                        */}

                    <div className="upload-contents-container">

                        <div className="upload-text-container">
                            <i class="fa-solid fa-cloud-arrow-up fa-2xl"></i><h2>Upload your CSV file</h2>
                            <p>Upload your CSV file to get started</p>
                        </div>

                        <div className="upload-text-container">
                        

                            <Field name="file" component={CustomFileInput} />
                            

                            <div className="upload-text-container"></div>
                            <ErrorMessage name="file" component="div" className="error-message"/>
                            <div className="button-container">
                                <button className="upload-button" type="submit" onClick={() => setButtonType('checkButton')}>Check</button>
                                
                                
                                {csvData.length>0 && showUploadButton &&(
                                <button className="upload-button" type="submit" onClick={() => setButtonType('uploadButton')}>Upload</button>
                                )}
                    
                            </div>
                            

                            <div>
                                {isLoading && (
                                    <div className="spinner">
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                        <div className="dot"></div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="upload-text-container">
                            {csvData ? (
                                <DataTable data={csvData} />
                            ) : (
                                // This is the "else" part
                                <div>
                                    Invalid CSV data. Please check your file and try again.
                                </div>
                            )}
                        </div>


                        <div className="upload-text-container">
                            <div className="csvtable-scrollable-div">   
                                {uploadData &&  (
                                    <UploadTable data={uploadData} />
                                )}
                            </div>
                        </div>
                    </div>
                </div>    
            </div>


            </Form>
        )}
        </Formik>
    );
};

export default FileUploadForm;
